import React from 'react'
import VideoPlayer from '../../../../ui/video_player/videoPlayer'

require("../video-plugins/videojs-markers.js");
require("../video-plugins/videojs.markers.min.css");

class EvaluationVideoPlayer extends VideoPlayer {
    static defaultProps = {
        onTimeUpdate: console.log,
        onVideoStateChange: console.log,
        thumbnail: null
    }

    triggerConstantTimeupdate = (interval = 500, roundFn = Math.floor, decimalPoint = 0) => {
        const constantTimeHandler = () => {
            clearInterval(this.timeHandler);
            let currentTime = roundFn(this.player.currentTime() * 10 ^ decimalPoint);
            this.timeHandler = setInterval(() => {
                currentTime = roundFn(this.player.currentTime() * 10 ^ decimalPoint);
                if (this.lastTime !== currentTime) {
                    this.player.trigger('constant-timeupdate', currentTime);
                    this.lastTime = currentTime;
                }
            }, interval);
        }
        this.player.on('play', constantTimeHandler);
        this.player.on('seeked', constantTimeHandler);
        this.player.on('pause', () => {
            clearInterval(this.timeHandler);
        });
        this.player.on('ended', () => {
            clearInterval(this.timeHandler);
        });
    }

    onVideoStateChange = (event) => {
        this.props.onVideoStateChange(event.type, this.player.currentTime());
    }

    onTimeUpdate = (event) => {
        this.props.onTimeUpdate(this.player.currentTime());
    }

    videoPlayerConfig = () => {
        return {
            autoplay: false,
            controls: true,
            fluid: true,
            responsive: true,
            aspectRatio: '16:9',
            poster: this.props.thumbnail,

            plugins: {
                videoJsResolutionSwitcher: {
                    default: 'low',
                    dynamicLabel: true,
                },
                markers: {
                    markerStyle: {
                        'width':'7px',
                        'height':'7px',
                        'background-color': '#FFF',
                        'box-shadow': '0px 2px 4px rgba(0, 0, 0, 0.04)',
                        'bottom': '-1px'
                    },
                    markerTip: {
                        display: false
                    }
                }
            },

            controlBar: {
                pictureInPictureToggle: false,
                fullscreenToggle: true,
                currentTimeDisplay: true,
                timeDivider: true,
                durationDisplay: true,
                liveDisplay: true,
                chaptersButton: true,
                subtitlesButton: true,
                captionsButton: true,
                volumePanel: false,

                playToggle: {
                    replay: false,
                },
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();

        // Config
        this.player.addClass("evaluation-video-player");
        this.player.bigPlayButton.addClass("vjs-icon-big-play-button");

        // Tigger customize 'timeupdate' event every 500ms with 2 numbers after the decimal point
        // this.triggerConstantTimeupdate(200, Math.ceil, 5)
        
        // Style Elements

        // Events
        // this.player.on('loadeddata', this.handleVideoStateChange);
        this.player.on('playing', this.onVideoStateChange);
        this.player.on('pause', this.onVideoStateChange);

        this.player.on('timeupdate', this.onTimeUpdate);

        // this.player.on('audioprocess', e => console.log('audioprocess', e))     //	The input buffer of a ScriptProcessorNode is ready to be processed.
        // this.player.on('canplay', e => console.log('canplay', e))               //	The browser can play the media, but estimates that not enough data has been loaded to play the media up to its end without having to stop for further buffering of content.
        // this.player.on('canplaythrough', e => console.log('canplaythrough', e)) //	The browser estimates it can play the media up to its end without stopping for content buffering.
        // this.player.on('complete', e => console.log('complete', e))             //	The rendering of an OfflineAudioContext is terminated.
        // this.player.on('durationchange', e => console.log('durationchange', e)) //	The duration attribute has been updated.
        // this.player.on('emptied', e => console.log('emptied', e))               //	The media has become empty; for example, this event is sent if the media has already been loaded(or partially loaded), and the load() method is called to reload it.
        // this.player.on('ended', e => console.log('ended', e))                   //	Playback has stopped because the end of the media was reached.
        // this.player.on('loadeddata', e => console.log('loadeddata', e))         //	The first frame of the media has finished loading.
        // this.player.on('loadedmetadata', e => console.log('loadedmetadata', e)) //	The metadata has been loaded.
        // this.player.on('pause', e => console.log('pause', e))                   //	Playback has been paused.
        // this.player.on('play', e => console.log('play', e))                     //	Playback has begun.
        // this.player.on('playing', e => console.log('playing', e))               //	Playback is ready to start after having been paused or delayed due to lack of data.
        // this.player.on('progress', e => console.log('progress', e))             //	Fired periodically as the browser loads a resource.
        // this.player.on('ratechange', e => console.log('ratechange', e))         //	The playback rate has changed.
        // this.player.on('seeked', e => console.log('seeked', e))                 //	A seek operation completed.
        // this.player.on('seeking', e => console.log('seeking', e))               //	A seek operation began.
        // this.player.on('stalled', e => console.log('stalled', e))               //	The user agent is trying to fetch media data, but data is unexpectedly not forthcoming.
        // this.player.on('suspend', e => console.log('suspend', e))               //	Media data loading has been suspended.
        // this.player.on('timeupdate', e => console.log('timeupdate', e))         //	The time indicated by the currentTimeattribute has been updated.
        // this.player.on('volumechange', e => console.log('volumechange', e))     //	The volume has changed.
        // this.player.on('waiting', e => console.log('waiting', e))               // Playback has stopped because of a temporary lack of data
    }

    componentWillReceiveProps = (nextProps) => {
        // Markers
        console.log(nextProps.markers);
        const newMarkers = nextProps.markers.map(m => ({ time: m.time, text: m.text }));
        
        this.player.markers.reset(newMarkers);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.player) this.player.off('playing')
    }

    render() {
        return (
            <video crossOrigin="anonymous" id="playerEvaluationVideo" ref={node => this.videoNode = node} className="video-js vjs-fluid"/>
        )
    }
}

export default React.memo(EvaluationVideoPlayer)